module.exports = __webpack_public_path__ + "static/media/symbol_bold__1080px__white.bc3aa509.png";